export const ventures = [
{
  id: 1,
  number: "01",
  year: "2024",
  name: "BasketballSphere.com",
  description: "The ultimate basketball media hub. News, analysis, player stats, game recaps, and in-depth coverage across NBA, EuroLeague, and global leagues.",
  tags: ["Basketball News", "Player Stats", "Game Analysis"],
  status: "Flagship",
  statusColor: "#22c55e"
},
{
  id: 2,
  number: "02",
  name: "BettingBros.com",
  description: "Curated directory of the best betting sites worldwide. Side-by-side comparisons, user ratings, bonus breakdowns, and trust scores.",
  tags: ["Site Directory", "Comparisons", "Reviews"],
  status: "Live",
  statusColor: "#22c55e"
},
{
  id: 3,
  number: "03",
  name: "Tipovi.com",
  description: "AI-powered betting tips and predictions. Machine learning models analyze form, odds movement, and historical data to deliver daily picks.",
  tags: ["AI Predictions", "Betting Tips", "Machine Learning"],
  status: "Growing",
  statusColor: "#3b82f6"
},
{
  id: 4,
  number: "04",
  name: "PokerPro.gg",
  description: "Poker room reviews, strategy content, and rakeback deals. Built for grinders, by grinders.",
  tags: ["Poker Strategy", "Rakeback", "Community"],
  status: "Stable",
  statusColor: "#22c55e"
},
{
  id: 5,
  number: "05",
  name: "Joker.gg",
  description: "Crypto-native betting platform reviews and guides. Covering Bitcoin, Ethereum, and altcoin wagering with provably fair verification.",
  tags: ["Crypto Betting", "Bitcoin", "Provably Fair"],
  status: "v3.0",
  statusColor: "#8b5cf6"
},
{
  id: 6,
  number: "06",
  name: "BetExperts.com",
  description: "Premium betting tips portal featuring expert tipsters, verified track records, and real-time performance stats across all major sports.",
  tags: ["Expert Tips", "Tipster Ratings", "Performance Stats"],
  status: "Beta",
  statusColor: "#eab308"
},
{
  id: 7,
  number: "07",
  name: "TopRated.casino",
  description: "Comprehensive casino review platform. In-depth operator ratings, RTP tracking, bonus analysis, and player-first trust scoring.",
  tags: ["Casino Reviews", "RTP Tracking", "Bonus Analysis"],
  status: "MVP Live",
  statusColor: "#22c55e"
}];


export const capabilities = [
{
  id: 1,
  number: "01",
  title: "Player Acquisition",
  description: "We engineer full-funnel acquisition strategies across SEO, paid media, and social — turning clicks into depositing players at scale.",
  tags: ["SEO", "PPC", "Social Media"],
  icon: "users"
},
{
  id: 2,
  number: "02",
  title: "Affiliate Technology",
  description: "Proprietary tracking infrastructure, real-time reporting dashboards, and intelligent attribution models built for performance.",
  tags: ["Tracking", "Attribution", "Dashboards"],
  icon: "layers"
},
{
  id: 3,
  number: "03",
  title: "Content & Creative",
  description: "Expert iGaming content at scale — reviews, guides, comparison pages, and multimedia assets that rank and convert.",
  tags: ["Reviews", "Guides", "Video"],
  icon: "palette"
},
{
  id: 4,
  number: "04",
  title: "Data & Analytics",
  description: "Deep player behavior analytics, cohort analysis, and predictive LTV modeling to optimize every stage of the funnel.",
  tags: ["Player Analytics", "LTV Models", "BI Tools"],
  icon: "barChart"
},
{
  id: 5,
  number: "05",
  title: "Compliance & Licensing",
  description: "We operate responsibly across regulated markets with full compliance frameworks, responsible gaming integration, and geo-targeting.",
  tags: ["Regulation", "Responsible Gaming", "Geo-Targeting"],
  icon: "shield"
},
{
  id: 6,
  number: "06",
  title: "CRO & Growth",
  description: "Conversion rate optimization through continuous A/B testing, UX improvements, and data-driven funnel engineering.",
  tags: ["A/B Testing", "UX", "Funnel Optimization"],
  icon: "trendingUp"
},
{
  id: 7,
  number: "07",
  title: "Operator Partnerships",
  description: "We build and manage strategic relationships with top-tier operators, negotiating premium deals and exclusive offers for our audiences.",
  tags: ["Negotiations", "Partnerships", "Revenue Share"],
  icon: "briefcase"
}];


export const teamMembers = [
{
  id: 1,
  name: "MaTEVZ R.",
  role: "Founder & CEO",
  focus: "VISION & STRATEGY",
  image: "https://ui-avatars.com/api/?name=MR&size=256&background=1a1a1a&color=fff&bold=true",
  email: "matevz@go2media.io"
},
{
  id: 2,
  name: "Milos S.",
  role: "Head of OPERATIONS",
  focus: "LOGISTICS & PROCESSES",
  image: "https://ui-avatars.com/api/?name=MS&size=256&background=1a1a1a&color=fff&bold=true",
  email: "milos@go2media.io"
},
{
  id: 3,
  name: "DUSAN S.",
  role: "Head of MARKETING",
  focus: "CAMPAIGNS & GROWTH",
  image: "https://ui-avatars.com/api/?name=DS&size=256&background=1a1a1a&color=fff&bold=true",
  email: "dusan@go2media.io"
},
{
  id: 4,
  name: "Miroslav D.",
  role: "Project Manager",
  focus: "EDITORIAL & PUBLISHING",
  image: "https://ui-avatars.com/api/?name=MD&size=256&background=1a1a1a&color=fff&bold=true",
  email: "miroslav@go2media.io"
},
{
  id: 5,
  name: "SRBA S.",
  role: "CONTENT WRITER",
  focus: "REVIEWS & GUIDES",
  image: "https://ui-avatars.com/api/?name=SS&size=256&background=1a1a1a&color=fff&bold=true",
  email: "srba@go2media.io"
},
{
  id: 6,
  name: "DEJAN G.",
  role: "CONTENT WRITER",
  focus: "COPY & SEO CONTENT",
  image: "https://ui-avatars.com/api/?name=DG&size=256&background=1a1a1a&color=fff&bold=true",
  email: "dejan@go2media.io"
}];


export const ongoingInitiatives = [
{ name: "Go2.casino", type: "EU Casino Portal", year: "2026" },
{ name: "To be announced ...", type: "Sports Insights", year: "2026" },
{ name: "To be announced ...", type: "Affiliate SaaS", year: "2026" },
{ name: "To be announced ...", type: "Player Safety", year: "2026" }];


export const stats = {
  monthlyVisits: "5M+",
  activeNodes: "12",
  established: "2018"
};

export const contactInfo = {
  availability: "3 Spots Left",
  availabilityMonth: "Q3 2025",
  location: "Malta / Remote",
  timezone: "CET / Global",
  avgResponse: "~ 4 Hours",
  email: "partnerships@go2media.io"
};

export const terminalLines = [
{ text: 'go2media_core:~$ ./deploy_acquisition_engine.sh', type: 'command' },
{ text: '> Initializing player funnels...', type: 'output' },
{ text: '> Optimizing conversion rates (100%)...', type: 'output' },
{ text: '> All operator feeds connected.', type: 'output' },
{ text: '>_', type: 'cursor' }];